/**
 * Fetch async data once then serve the data from memory
 * @param {RequestInfo} url - url param
 * @param {RequestInit} [opts] - fetch options
 * @param {number} [cacheTime] - optional cache time to clear results from memory
 */
export const getJSONOneTime = (url, opts, cacheTime) => {
	let data = null;
	/**
	 * @type {Promise<Response>}
	 */
	let onGoingRequest = null;

	return () => {
		if (data) return Promise.resolve(data);
		if (onGoingRequest) return onGoingRequest;

		const request = fetch(url, opts).then((resp) => {
			data = resp.json();
			// If we have cacheTime clear data after cacheTime has passed
			if (cacheTime) {
				setTimeout(() => { data = null; }, cacheTime);
			}
			onGoingRequest = null;
			return data;
		});
		onGoingRequest = request;
		return request;
	};
};